'use strict';

var PropTypes = require('prop-types');
var React = require('react');
var createReactClass = require('create-react-class');
var LocalizeMixin = require("../../../localization/CommonLocalizationMixin");
var TransitionMixin = require('../../../mixins/TransitionMixin');
var EmailSignUpButton = require('../SignUpButtons/Email/emailSignUpButton.js');
var FacebookSignUpButton = require('../SignUpButtons/Facebook/facebookSignUpButton.js');
var GoogleSignUpButton = require('../SignUpButtons/Google/googleSignUpButton.js');
var JoinButton = require('../SignUpButtons/JoinButton/joinButton.js');
var FacebookLoginApiHelper = require("../../../lib/social/FacebookLoginApiHelper");

module.exports = createReactClass({
    displayName: 'exports',

    mixins: [LocalizeMixin, TransitionMixin],
    propTypes: {
        handleJoinRewardsClick: PropTypes.func.isRequired,
        handleEmailSignUpClick: PropTypes.func.isRequired,
        handleGoogleSignUpClick: PropTypes.func.isRequired,
        handleFbSignUpClick: PropTypes.func.isRequired,
        removeErrorFromProps: PropTypes.func.isRequired,
        handleLogInClick: PropTypes.func.isRequired,
        isLoggedIn: PropTypes.bool.isRequired,
        errors: PropTypes.array,
        showLoadingSpinner: PropTypes.func.isRequired,
        hideLoadingSpinner: PropTypes.func.isRequired
    },
    componentWillMount: function componentWillMount() {
        FacebookLoginApiHelper.loadFbLoginApi();
    },
    handleJoinRewardsClick: function handleJoinRewardsClick() {
        if (this.props.handleJoinRewardsClick) {
            this.props.handleJoinRewardsClick();
        }
    },
    handleEmailSignUpClick: function handleEmailSignUpClick() {
        if (this.props.handleEmailSignUpClick) {
            this.props.handleEmailSignUpClick();
        }
    },
    handleGoogleSignUpClick: function handleGoogleSignUpClick() {
        if (this.props.handleGoogleSignUpClick) {
            this.props.handleGoogleSignUpClick();
        }
    },
    handleFbSignUpClick: function handleFbSignUpClick() {
        this.props.showLoadingSpinner();
        FacebookLoginApiHelper.loginWithFacebook(this.props.handleFbSignUpClick, this.props.hideLoadingSpinner);
    },
    removeErrorFromProps: function removeErrorFromProps(idx) {
        if (this.props.removeErrorFromProps) {
            this.props.removeErrorFromProps(idx);
        }
    },
    handleLogInClick: function handleLogInClick() {
        if (this.props.handleLoginClick) {
            this.props.handleLoginClick();
        } else {
            this.transitionTo('/login');
        }
    },
    render: function render() {
        var _this = this;

        var signInText = this.getLocalizedText("value_proposition_login_text1");
        var login = this.getLocalizedText("value_proposition_login_text2");

        var errors = this.props.errors && this.props.errors.length > 0 ? this.props.errors.map(function (error, idx) {
            return React.createElement(
                'p',
                { key: "prop-err" + idx, className: 'bg-danger alert-danger alert' },
                error,
                React.createElement(
                    'span',
                    { 'aria-hidden': 'true', className: 'close', onClick: _this.removeErrorFromProps.bind(_this, idx) },
                    '\xD7'
                )
            );
        }) : [];

        return React.createElement(
            'div',
            { className: 'loyalty-value-proposition ' + (this.props.isLoggedIn ? 'logged-in' : '') },
            React.createElement(
                'div',
                { className: 'container error-container', 'aria-live': 'polite' },
                errors
            ),
            React.createElement(
                'div',
                { className: 'container' },
                React.createElement(
                    'div',
                    { className: 'hero-container' },
                    React.createElement('img', { className: 'hidden-sm reward-logo', src: '/images/common/ic_newrew_desktop.svg', alt: 'New Rewards' }),
                    React.createElement('img', { className: 'visible-sm-inline reward-logo', src: '/images/common/ic_rew_logo_sm.png', alt: 'New Rewards' }),
                    React.createElement(
                        'div',
                        { className: 'free-item' },
                        React.createElement(
                            'span',
                            null,
                            this.getLocalizedText('rewards_free_single'),
                            '*'
                        ),
                        React.createElement(
                            'span',
                            { className: 'with-purchase' },
                            this.getLocalizedText('rewards_join_value_prop_with_purchase')
                        )
                    ),
                    !this.props.isLoggedIn && React.createElement(
                        'div',
                        { className: 'sign-up-options' },
                        React.createElement(EmailSignUpButton, { onClick: this.handleEmailSignUpClick }),
                        React.createElement(FacebookSignUpButton, { onClick: this.handleFbSignUpClick }),
                        React.createElement(GoogleSignUpButton, { onClick: this.handleGoogleSignUpClick }),
                        React.createElement(
                            'div',
                            { className: 'sign-in IntroRegular' },
                            React.createElement(
                                'span',
                                { id: 'log-in-label' },
                                signInText
                            ),
                            React.createElement(
                                'a',
                                { className: 'IntroBold', 'aria-describedby': 'log-in-label', href: '#', onClick: this.handleLogInClick },
                                login
                            )
                        )
                    ),
                    this.props.isLoggedIn && React.createElement(
                        'div',
                        { className: 'sign-up-options' },
                        React.createElement(JoinButton, {
                            cntry: this.props.cntry,
                            lang: this.props.lang,
                            onClick: this.handleJoinRewardsClick })
                    )
                ),
                React.createElement(
                    'div',
                    { className: 'how-it-works-container' },
                    React.createElement(
                        'h1',
                        null,
                        this.getLocalizedText('easy_as')
                    ),
                    React.createElement(
                        'div',
                        { className: 'steps' },
                        React.createElement(
                            'div',
                            { className: 'step' },
                            React.createElement(
                                'h2',
                                null,
                                this.getLocalizedText('rewards_one'),
                                ' ',
                                React.createElement(
                                    'span',
                                    { className: 'step-instruction' },
                                    this.getLocalizedText('email_sign_up')
                                )
                            ),
                            React.createElement(
                                'p',
                                { className: 'copy' },
                                this.getLocalizedText('rewards_one_text')
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'step' },
                            React.createElement(
                                'h2',
                                null,
                                this.getLocalizedText('rewards_two'),
                                ' ',
                                React.createElement(
                                    'span',
                                    { className: 'step-instruction' },
                                    this.getLocalizedText('rewards_two_title')
                                )
                            ),
                            React.createElement(
                                'p',
                                { className: 'copy' },
                                this.getLocalizedText('rewards_two_text')
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'step' },
                            React.createElement(
                                'h2',
                                null,
                                this.getLocalizedText('rewards_three'),
                                ' ',
                                React.createElement(
                                    'span',
                                    { className: 'step-instruction' },
                                    this.getLocalizedText('rewards_three_title')
                                )
                            ),
                            React.createElement(
                                'p',
                                { className: 'copy' },
                                this.getLocalizedText('rewards_three_text')
                            )
                        )
                    )
                ),
                React.createElement(
                    'div',
                    { 'class': 'enrollment-disclaimer' },
                    this.getLocalizedText('rewards_enrollment_disclaimer')
                )
            )
        );
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/loginComponents/loyalty/loyaltyValueProposition.js
// module id = 747
// module chunks = 0